"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ParentChildRelationshipAlreadyExistsError extends client_library_1.ExtendableError {
    constructor() {
        super('Parent child relationship already exists');
    }
}
exports.default = ParentChildRelationshipAlreadyExistsError;
//# sourceMappingURL=ParentChildRelationshipAlreadyExistsError.js.map